import { forwardRef, type Ref, type SVGProps } from "react";
const IconTreesFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29 28h-6v-8.09A5.98 5.98 0 0 0 25.58 9.2a4.5 4.5 0 1 0-7.16 0A5.98 5.98 0 0 0 21 19.91V28H10v-3.6a5.5 5.5 0 0 0 2.12-9.93A3.96 3.96 0 0 0 13 12a4 4 0 0 0-8 0 3.96 3.96 0 0 0 .88 2.47A5.5 5.5 0 0 0 8 24.4V28H3a1 1 0 0 0 0 2h26a1 1 0 0 0 0-2m-8-15a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0zM9.04 23h-.08a.96.96 0 0 1-.96-.96v-4.08a.96.96 0 0 1 .96-.96h.08a.96.96 0 0 1 .96.96v4.08a.96.96 0 0 1-.96.96" />
  </svg>
);
const ForwardRef = forwardRef(IconTreesFilledSVG);
ForwardRef.displayName = "IconTreesFilled";
export { ForwardRef as IconTreesFilled };
